(function () {
  function getVariantIdFromForm(form) {
    var idInput = form.querySelector('[name="id"]');
    return idInput ? String(idInput.value) : null;
  }

  function findProductScope(form) {
    return (
      form.closest('.product') ||
      form.closest('[data-section-type*="product"]') ||
      form.closest('section') ||
      document
    );
  }

  function getAddButtons(form) {
    var scope = findProductScope(form);
    var buttons = [];

    form.querySelectorAll('button[type="submit"], button[name="add"], [type="submit"][name="add"]').forEach(function (btn) {
      buttons.push(btn);
    });

    scope.querySelectorAll('[name="add"], .product-form__submit, .product-form button[type="submit"]').forEach(function (btn) {
      if (buttons.indexOf(btn) === -1) buttons.push(btn);
    });

    return buttons;
  }

  function getDynamicCheckoutButtons(form) {
    var scope = findProductScope(form);
    return scope.querySelectorAll('.shopify-payment-button, shopify-payment-terms');
  }

  function createMessage(form) {
    var existing = form.querySelector('.th-stock-buffer-message');
    if (existing) return existing;

    var message = document.createElement('div');
    message.className = 'th-stock-buffer-message';
    message.setAttribute('role', 'status');
    message.style.display = 'none';

    var button = form.querySelector('[name="add"], button[type="submit"]');

    if (button && button.parentNode) {
      button.parentNode.insertBefore(message, button.nextSibling);
    } else {
      form.appendChild(message);
    }

    return message;
  }

  function setButtonText(button, text, blocked) {
    if (!button) return;

    if (!button.dataset.thOriginalText) {
      button.dataset.thOriginalText = button.textContent.trim();
    }

    if (blocked) {
      button.textContent = text;
    } else {
      button.textContent = button.dataset.thOriginalText || 'Add to cart';
    }
  }

  function updateForm(form) {
    var config = window.ThStockBufferConfig || {};
    if (!config.enabled) return;

    var variantId = getVariantIdFromForm(form);
    if (!variantId || !config.variants || !config.variants[variantId]) return;

    var variant = config.variants[variantId];
    var blocked = !variant.buffer_available;
    var messageText = config.message || 'Out of stock online';

    var buttons = getAddButtons(form);
    var message = createMessage(form);
    var dynamicButtons = getDynamicCheckoutButtons(form);

    buttons.forEach(function (button) {
      button.disabled = blocked;
      button.setAttribute('aria-disabled', blocked ? 'true' : 'false');
      button.classList.toggle('th-stock-buffer-disabled', blocked);
      setButtonText(button, messageText, blocked);
    });

    dynamicButtons.forEach(function (el) {
      el.style.display = blocked ? 'none' : '';
    });

    message.textContent = blocked ? messageText + ' — please select another variant or contact us.' : '';
    message.style.display = blocked ? 'block' : 'none';

    form.classList.toggle('th-stock-buffer-blocked', blocked);
  }

  function updateAllForms() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(updateForm);
  }

  document.addEventListener('change', function (event) {
    if (
      event.target.matches('select') ||
      event.target.matches('input[type="radio"]') ||
      event.target.matches('input[name="id"]')
    ) {
      setTimeout(updateAllForms, 80);
      setTimeout(updateAllForms, 250);
    }
  });

  document.addEventListener('click', function () {
    setTimeout(updateAllForms, 120);
  });

  document.addEventListener('DOMContentLoaded', function () {
    updateAllForms();
    setTimeout(updateAllForms, 500);
  });

  document.addEventListener('shopify:section:load', function () {
    updateAllForms();
  });

  var lastUrl = location.href;
  setInterval(function () {
    if (location.href !== lastUrl) {
      lastUrl = location.href;
      setTimeout(updateAllForms, 150);
    }
  }, 300);
})();